import { helpdeskConfigurationValuesTypes } from "../../types";


export const helpdeskDefaultValues: helpdeskConfigurationValuesTypes = {


    complaintTypes: {
        "name": "complaintTypes",
        "type": "list",
        "value": [
            "App Related",
            "Quality Related",
            "Supply Related",
            "Feedback",
            "Other Issues"
        ],
        "docUrl": "",
        "description": ".",
        "possibleVals": [

        ]
    },
    priorityTypes: {
        "name": "priorityTypes",
        "type": "list",
        "value": [
            "Low",
            "Medium",
            "High"
        ],
        "docUrl": "",
        "description": "",
        "possibleVals": [

        ]
    },




}